import storeService from "../services/store.service";
import { toogleErrorMessage, toogleSuccessMessage } from "./alertMessage";
import { STORE_BYID_LIST, STORE_LIST, STORE_LIST_LOADER } from "./type";

export const storeDetails = (search, page, limit) => (dispatch) => {
  dispatch({ type: STORE_LIST_LOADER, payload: true });
  return storeService.storeList(search, page, limit).then((resp) => {
    if (resp.status === 200) {
      dispatch({ type: STORE_LIST, payload: resp.data });
    } else {
      dispatch({ type: STORE_LIST_LOADER, payload: null });
    }
    return resp;
  });
};
export const allStores = () => async (dispatch) => {
  dispatch({ type: STORE_LIST_LOADER, payload: true });
  try {
    const resp = await storeService.allStoresList();

    if (resp.status === 200) {
      dispatch({ type: STORE_LIST, payload: resp.data });
    } else {
      dispatch({ type: STORE_LIST_LOADER, payload: false });
    }

    return resp;
  } catch (error) {
    dispatch({ type: STORE_LIST_LOADER, payload: false });
  }
};
export const storeListDeleteAction = (id) => async (dispatch) => {
  return await storeService.storeListDelete(id).then((resp) => {
    if (resp.status === 200) {
      dispatch(toogleSuccessMessage("Store deleted successfully"));
    } else {
      dispatch(
        toogleErrorMessage(
          resp.response.data.message || "Something wen't wrong"
        )
      );
    }
    return resp;
  });
};

export const storeAddAction = (payload) => async (dispatch) => {
  return await storeService.storeAdd(payload).then((resp) => {
    if (resp.status === 200) {
      dispatch(toogleSuccessMessage("Store add successfully"));
    } else {
      dispatch(
        toogleErrorMessage(
          resp.response.data.message || "Something wen't wrong"
        )
      );
    }
    return resp;
  });
};

export const storeByIdAction = (id) => (dispatch) => {
  return storeService.getStoreById(id).then((resp) => {
    if (resp.status === 200) {
      dispatch({ type: STORE_BYID_LIST, payload: resp.data });
    }
    return resp;
  });
};

export const editStoreAction = (id, payload) => async (dispatch) => {
  return await storeService.editStore(id, payload).then((resp) => {
    if (resp.status === 200) {
      dispatch(toogleSuccessMessage("Store updated successfully"));
    } else {
      dispatch(
        toogleErrorMessage(
          resp.response.data.message || "Something wen't wrong"
        )
      );
    }
    return resp;
  });
};

export const approvedStoreAction = (id, payload) => async (dispatch) => {
  return await storeService.approvedStore(id, payload).then((resp) => {
    if (resp.status === 200) {
      dispatch(
        toogleSuccessMessage(
          resp.data.data.message || "Store updated successfully"
        )
      );
    } else {
      dispatch(
        toogleErrorMessage(
          resp.response.data.message || "Something wen't wrong"
        )
      );
    }
    return resp;
  });
};
